/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardVendor from '../../components/card-vendor'
import icOne from '../../static/icons/vendor/fix/ic-1.svg'
import icTwo from '../../static/icons/vendor/fix/ic-2.svg'
import icThree from '../../static/icons/vendor/fix/ic-3.svg'
import icFour from '../../static/icons/vendor/fix/ic-4.svg'
import { TitleTwo, TextBodyOne } from '../../components/text'
import { Style } from './vendor.styles'

const VendorFix = () => {
  const { t } = useTranslation();

  return (
    <Style>
      <Grid>
        <Row middle="lg">
          <Col lg={4} md={12} sm={12} xs={12}>
            <Row middle="lg">
              <Col lg={12} md={12} sm={12} xs={12} className="bottom-margin">
                <div className="bottom-margin">
                  <TitleTwo>
                    {t('pageServiceAcJakarta.part38')}
                  </TitleTwo>
                </div>
                <TextBodyOne>
                  {t('pageServiceAcJakarta.part39')}
                </TextBodyOne>
              </Col>
            </Row>
          </Col>
          <Col lg={8} md={12} sm={12} xs={12}>
            <Row className="row-align-items">
              <Col lg={3} sm={3} xs={6} md={3} className="bottom-margin">
                <CardVendor
                  title={t('pageServiceAcJakarta.part40')}
                  image={icOne}
                ></CardVendor>
              </Col>
              <Col lg={3} sm={3} xs={6} md={3} className="bottom-margin">
                <CardVendor
                  title={t('pageServiceAcJakarta.part41')}
                  image={icTwo}
                ></CardVendor>
              </Col>
              <Col lg={3} sm={3} xs={6} md={3} className="bottom-margin">
                <CardVendor
                  title={t('pageServiceAcJakarta.part42')}
                  image={icThree}
                ></CardVendor>
              </Col>
              <Col lg={3} sm={3} xs={6} md={3} className="bottom-margin">
                <CardVendor
                  title={t('pageServiceAcJakarta.part43')}
                  image={icFour}
                ></CardVendor>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default VendorFix
